export default "__VITE_PUBLIC_ASSET__4918ec4d__"